import CreateShopSupplierRequestModelBase from '../_generated/modelBases/create-shop-supplier-request-model-base';

export default class CreateShopSupplierRequestModel extends CreateShopSupplierRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
